import React from 'react';
import RichTextEditor from './RichTextEditor';
import { TokenInfo } from './Chat';

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  onGenerate: () => void;
  loading: boolean;
  tokens: TokenInfo[];
}

const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  onGenerate,
  loading,
  tokens
}) => {
  return (
    <div className="text-input-container">
      <div className="input-header">
        <label className="input-label">Enter your text</label>
        {tokens.length > 0 && (
          <span className="badge bg-success">
            {tokens.length} tokens generated
          </span>
        )}
      </div>

      <RichTextEditor
        initialText={value}
        tokens={tokens}
        onTextChange={onChange}
        disabled={loading}
      />

      <button
        className="generate-button btn btn-primary btn-lg"
        onClick={onGenerate}
        disabled={loading || !value.trim()}
        aria-busy={loading}
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Generating...
          </>
        ) : (
          <>
            <span aria-hidden="true">✨</span> Generate completion
          </>
        )}
      </button>
    </div>
  );
};

export default TextInput;